export enum BrandEnum {
    Orange = 'ORANGE',
    Sosh = 'SOSH',
}
